export interface RunnerAdapter<TRequest, TResult> {
	readonly type: string;
	run(request: TRequest): Promise<TResult>;
}

export class PiRunner<TRequest, TResult> implements RunnerAdapter<TRequest, TResult> {
	readonly type = "pi";
	private readonly execute: (request: TRequest) => Promise<TResult>;

	constructor(execute: (request: TRequest) => Promise<TResult>) {
		this.execute = execute;
	}

	run(request: TRequest): Promise<TResult> {
		return this.execute(request);
	}
}
